import { IMAGES } from "@/data/content";
import { useLang } from "@/context/LanguageContext";

export const BrandCarousel = () => {
  const { t } = useLang();

  return (
    <section
      data-testid="brand-carousel-section"
      aria-label={t.brands.aria}
      className="brand-carousel py-7 sm:py-9"
    >
      <div className="brand-carousel__viewport">
        <div className="brand-carousel__track">
          {[false, true].map((duplicate) => (
            <div key={String(duplicate)} className="brand-carousel__set" aria-hidden={duplicate}>
              {IMAGES.brandLogos.map((logo) => (
                <div key={`${duplicate}-${logo.name}`} className="brand-carousel__logo">
                  <img
                    src={logo.src}
                    alt={duplicate ? "" : logo.name}
                    data-testid={duplicate ? undefined : `brand-logo-${logo.name.toLowerCase().replace(/\s+/g, "-")}`}
                    className="brand-carousel__image"
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};